import Styles from './ErrorReferenceImage.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowRotateLeft } from 'blaze-ui/icons/24'
import { useCreateReferenceImage } from 'hooks/queries/schedules/contents/useCreateReferenceImage'
import { ErrorReferenceImageProps } from 'screens/Schedule/PostPromptsSection/Types'
import { UpdateReferenceImageTrigger } from 'screens/Schedule/PostPromptsSection/UpdateReferenceImageTrigger'
import { Upload5 } from 'blaze-ui/icons'

export const ErrorReferenceImage = ({ scheduleId, contentId }: ErrorReferenceImageProps) => {
  const { mutate: createReferenceImage } = useCreateReferenceImage()
  return (
    <div className={Styles.image}>
      <div className={Styles.label}>
        <Text variant="placeholder">
          No image matched.
          <br />
          Pick one or we'll try again when generating content.
        </Text>
      </div>
      <div className={Styles.buttonContainer}>
        <Button
          frontIcon={ArrowRotateLeft}
          onPress={() => createReferenceImage({ scheduleId, contentId })}
          aria-label="Retry"
          variant="secondary"
          size="sm"
        >
          Retry
        </Button>
        <UpdateReferenceImageTrigger scheduleId={scheduleId} contentId={contentId}>
          <Button frontIcon={Upload5} aria-label="Upload" variant="secondary" size="sm">
            Upload
          </Button>
        </UpdateReferenceImageTrigger>
      </div>
    </div>
  )
}
